import React from 'react';
import Label from 'shared/components/label';
import Fieldset from 'shared/components/fieldset';
import FormikTextField from 'src/components/FormikTextField';
import {useField} from 'formik';
import {ordinalNumber} from 'shared/utils';
import Button from 'src/components/button';
import styles from 'src/views/admin/TimeSensitiveItemTypes/Details/Details.module.scss';
import PhotoUpload from 'shared/components/form-inputs/time-sensitive-items/photo-upload';

export interface TestimonialProps {
  // TODO: used in files that import this type
  // eslint-disable-next-line react/no-unused-prop-types
  testimonial: object;
  index: number;
  removeTestimonial: (index: number) => void;
}

const Testimonial = (props: TestimonialProps) => {
  const {index, removeTestimonial} = props;

  const [avatarField, , avatarFieldHelpers] = useField(`testimonials[${props.index}].avatarUrl`);
  const {value} = avatarField;
  const onChange = (newValue): void => {
    avatarFieldHelpers.setValue(newValue);
  };

  const PhotoUploadComponent = <PhotoUpload onChange={onChange} value={value} />;

  return (
    <div key={index} className={styles.fieldBorder}>
      {`${ordinalNumber(index + 1)} Testimonial`}
      <Fieldset>
        <Fieldset.Legend>Avatar URL</Fieldset.Legend>
        {PhotoUploadComponent}
      </Fieldset>
      <Label>
        Name
        <FormikTextField name={`testimonials[${index}].name`} placeholder="Joe B. Student" />
      </Label>
      <Label>
        Graduation Year
        <FormikTextField name={`testimonials[${index}].gradYear`} placeholder="2024" />
      </Label>
      <Label>
        Text
        <FormikTextField name={`testimonials[${index}].text`} placeholder="This was so cool" />
      </Label>
      <Button
        aria-label="Remove testimonial"
        size="small"
        color="negative"
        onClick={() => removeTestimonial(index)}
      >
        {`Delete ${ordinalNumber(index + 1)} Testimonial`}
      </Button>
    </div>
  );
};

export default Testimonial;
